export default "__VITE_ASSET__DTX52xWc__"